import { useEffect, useState } from 'react';

// Height of the fixed desktop top bar (nav/DashboardTopBar). Anything sized
// against the viewport on desktop subtracts it.
export const DASHBOARD_TOPBAR_H = 56;

// Desktop pages sit in a rounded white card floating on the app backdrop:
// this is the gap between the card and the viewport edges / the sidebar.
export const DASHBOARD_FRAME_GAP = 8;
export const DASHBOARD_FRAME_RADIUS = '16px';
// Soft tinted backdrop behind the sidebar rail and the page card.
export const DASHBOARD_BACKDROP = 'linear-gradient(160deg, #EEF3FB 0%, #F4F6F9 45%, #EEF6F3 100%)';

// Desktop sidebar widths — the single source for the sidebar itself and for
// everything offset by it (top bar, page container, full-bleed pages).
export const DASHBOARD_NAV_W = 200;
export const DASHBOARD_NAV_W_COLLAPSED = 64;

// The icon rail is the default; the labelled sidebar is opt-in (`navExpanded`).
export const readNavCollapsed = () => {
  try {
    return !JSON.parse(localStorage.getItem('navExpanded'));
  } catch {
    return true; // corrupt value → rail
  }
};

const readNavWidth = () => {
  const collapsed = readNavCollapsed();
  // The old resizable sidebar persisted a `navWidth` key; it is deliberately
  // ignored — a stale value would offset the pages away from the real sidebar.
  return collapsed ? DASHBOARD_NAV_W_COLLAPSED : DASHBOARD_NAV_W;
};

/**
 * Width of the desktop sidebar (expanded or collapsed). DashboardNavbar
 * dispatches `dashboardNavResize` on every change.
 */
const useDashboardNavWidth = () => {
  const [navWidth, setNavWidth] = useState(readNavWidth);

  useEffect(() => {
    const handleResize = () => setNavWidth(readNavWidth());
    window.addEventListener('dashboardNavResize', handleResize);
    return () => window.removeEventListener('dashboardNavResize', handleResize);
  }, []);

  return navWidth;
};

export default useDashboardNavWidth;
